<template>
    <div class="index">
      <div class="left-content">
        <div class="sub_title">
          <h2>Online learning module</h2>
        </div>
        <h1>Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to the nonsteroidal MRA, finerenone</h1>
        <p class="tips">
          This online module will take you ~40 mins to complete.
        </p>
        <router-link class="btn btn_kerendia" to="/section1">Start module</router-link>
        <div class="left-ctn-btm">
          <p>This module has been developed and funded by Bayer</p>
          <img src="../assets/images/home-l-b.png" />
        </div>
        <div class="notice">CKD, chronic kidney disease, MRA, mineralocorticoid receptor antagonist.</div>
      </div>
      <div class="right-content">
        <MainMenu></MainMenu>
      </div>
    </div>
</template>

<script>
import MainMenu from "../components/MainMenu";
export default {
    name: "Index",
  components: {MainMenu}
}
</script>

<style scoped>
@import "../assets/css/index.css";
</style>
